import { isCpf } from 'iscpf';

export const isValidCPF = (cpf) => {
  if (window.nonValidationsModeIsActive) return true;
  return cpf
    ? !cpf.replace(/[._-]+/gi, '').match(/^(.)\1+$/) && isCpf(cpf)
    : true;
};

export const heroValidators = {
  rules: {
    validate: {
      isValidCPF: (cpf) => isValidCPF(cpf),
    },
  },
  messages: {
    isValidCPF: 'cpf inválido',
  },
};
